import { render } from "./my.vue?vue&type=template&id=0409a10a&scoped=true&ts=true"
import script from "./my.vue?vue&type=script&lang=ts"
export * from "./my.vue?vue&type=script&lang=ts"

import "./my.vue?vue&type=style&index=0&id=0409a10a&lang=less&scoped=true"
import "./my.vue?vue&type=style&index=1&id=0409a10a&lang=less"

import exportComponent from "E:\\lcz\\WX.My\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0409a10a"]])

export default __exports__